<!-- dialog content: Refer Fax -->
<ng-template #referFaxDialogTemplate>
  <app-refer-fax (referFaxEvent)="faxReferred($event)" [showInContentCancelReferBtn]="true" (cancelReferEvent)="cancelRefer()"></app-refer-fax>
</ng-template>